import { useSyncExternalStore } from 'react';
import { CANVAS_SESSION_EXPIRED_EVENT } from '~/utils/constants/common';

// Set by the event axiosClient sends on code 60004. It never goes back to false: a new Canvas
// login always goes through the OAuth redirect, which reloads the page.
let isCanvasSessionExpired = false;
const listeners = new Set<() => void>();

window.addEventListener(CANVAS_SESSION_EXPIRED_EVENT, () => {
  if (isCanvasSessionExpired) return;
  isCanvasSessionExpired = true;
  listeners.forEach((listener) => listener());
});

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/** True once the backend can no longer renew the Canvas session: only a new login fixes it. */
export function useCanvasSessionExpired(): boolean {
  return useSyncExternalStore(subscribe, () => isCanvasSessionExpired);
}
